import http from 'constants/config';

export const getDwellingAccountN = did => http.get(`v2/dwellings/by/id/${ did }/account`);
